import logoSymbol from "@/assets/logo-symbol.png";

const BrandLoader = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-background">
    <img
      src={logoSymbol}
      alt="Carregando"
      className="h-16 w-16 animate-pulse object-contain"
    />
  </div>
);

export default BrandLoader;
